import React, { useState } from 'react';
import { MapPin, Star, TrendingUp, Image as ImageIcon } from 'lucide-react';

const RecommendedThumb = ({ src, alt }) => {
  const [error, setError] = useState(false);

  if (!src || error) {
    return (
      <div className="pub-cus-des-rec-img-wrap pub-cus-des-rec-img-placeholder">
        <ImageIcon size={20} />
      </div>
    );
  }

  return (
    <div className="pub-cus-des-rec-img-wrap">
      <img
        src={src}
        alt={alt}
        className="pub-cus-des-rec-img"
        loading="lazy"
        onError={() => setError(true)}
      />
    </div>
  );
};

const RecommendedDestinations = ({ currentDestination, allDestinations, onSelect, imageBaseUrl }) => {
  const imgUrl = (path) => (path ? `${imageBaseUrl}/${path}` : null);

  const recommendations = allDestinations
    .filter((d) => d.id !== currentDestination.id)
    .filter((d) => !d.status || d.status === 'Active') // only recommend active destinations
    .map((d) => {
      let score = 0;
      if (d.province === currentDestination.province) score += 3;
      if (d.climate   === currentDestination.climate)   score += 1;
      if (d.best_season === currentDestination.best_season) score += 1;
      return { ...d, score };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, 5);

  return (
    <div className="pub-cus-des-recommended-container">
      <h4 className="fw-bold mb-1 d-flex align-items-center gap-2" style={{ fontSize: '1rem', color: '#1B4965' }}>
        <Star size={18} style={{ color: '#FFB800' }} />
        You May Also Like
      </h4>
      <p className="text-muted mb-3" style={{ fontSize: '0.78rem' }}>
        Similar destinations based on province &amp; season
      </p>

      {recommendations.length > 0 ? (
        <div className="pub-cus-des-recommended-list">
          {recommendations.map((dest) => (
            <div key={dest.id} className="pub-cus-des-rec-card card">
              <div className="row g-0">
                <div className="col-5">
                  <RecommendedThumb
                    src={imgUrl(dest.image) || imgUrl(dest.jjdestinationgallerys?.[0]?.des_gallery)}
                    alt={dest.destination_name}
                  />
                </div>
                <div className="col-7">
                  <div className="card-body p-3">
                    <div className="pub-cus-des-rec-title">{dest.destination_name}</div>
                    <p className="text-muted mb-2 d-flex align-items-center gap-1" style={{ fontSize: '0.75rem' }}>
                      <MapPin size={11} />
                      {dest.province}
                    </p>

                    <div className="d-flex flex-wrap gap-1 mb-1">
                      {dest.province === currentDestination.province && (
                        <span className="pub-cus-des-match-tag">
                          <TrendingUp size={9} /> Same Province
                        </span>
                      )}
                      {dest.best_season === currentDestination.best_season && (
                        <span className="pub-cus-des-match-tag">Same Season</span>
                      )}
                    </div>

                    <button
                      className="pub-cus-des-rec-explore-btn"
                      onClick={() => onSelect(dest)}
                    >
                      Explore
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-3">
          <p className="text-muted small mb-0">No similar destinations found.</p>
        </div>
      )}
    </div>
  );
};

export default RecommendedDestinations;